import type { Specialty } from '@q4udoc/types';
import { useGetList } from 'react-admin';

export const useSpecialtyOptions = () => {
  const { data: specialties } = useGetList('specialties', {
    pagination: { page: 1, perPage: 500 },
    sort: { field: 'name', order: 'ASC' },
    filter: {},
  });

  return specialties?.map((s: Specialty) => ({ id: s.name, name: s.name })) ?? [];
};
